import * as Types from '../types-api.generated';

import { UserLightFragment, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, WorldOverviewFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiExhibitionCollectorsVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  currentUserPublicKey?: Types.InputMaybe<Types.Scalars['String']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiExhibitionCollectors = { exhibitionCollectorStats: { totalItems: number, page: number, totalPages: number, items: Array<{ isFollowingUser: boolean, user: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } }> } };



export const ApiExhibitionCollectorsDocument = /*#__PURE__*/ `
    query ExhibitionCollectors($id: Int!, $currentUserPublicKey: String, $page: Int, $perPage: Int) {
  exhibitionCollectorStats(
    exhibitionId: $id
    accountAddress: $currentUserPublicKey
    page: $page
    perPage: $perPage
  ) {
    totalItems
    page
    totalPages
    items {
      user {
        ...UserLightFragment
      }
      isFollowingUser: isFollowing
    }
  }
}
    ${UserLightFragment}`;

export const useExhibitionCollectors = <
      TData = ApiExhibitionCollectors,
      TError = ClientError
    >(
      variables: ApiExhibitionCollectorsVariables,
      options?: Omit<UseQueryOptions<ApiExhibitionCollectors, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiExhibitionCollectors, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiExhibitionCollectors, TError, TData>(
      {
    queryKey: ['ExhibitionCollectors', variables],
    queryFn: apiFetcher<ApiExhibitionCollectors, ApiExhibitionCollectorsVariables>(ApiExhibitionCollectorsDocument, variables),
    ...options
  }
    )};

useExhibitionCollectors.getKey = (variables: ApiExhibitionCollectorsVariables) => ['ExhibitionCollectors', variables];

export const useInfiniteExhibitionCollectors = <
      TData = InfiniteData<ApiExhibitionCollectors>,
      TError = ClientError
    >(
      variables: ApiExhibitionCollectorsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiExhibitionCollectors, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiExhibitionCollectors, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiExhibitionCollectors, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ExhibitionCollectors.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiExhibitionCollectors, ApiExhibitionCollectorsVariables>(ApiExhibitionCollectorsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteExhibitionCollectors.getKey = (variables: ApiExhibitionCollectorsVariables) => ['ExhibitionCollectors.infinite', variables];


useExhibitionCollectors.fetcher = (variables: ApiExhibitionCollectorsVariables, options?: RequestInit['headers']) => apiFetcher<ApiExhibitionCollectors, ApiExhibitionCollectorsVariables>(ApiExhibitionCollectorsDocument, variables, options);
